import { Box } from '@mui/material'
import { ChevronLeft20Regular, ChevronRight20Regular } from '@/components/Icon'
import styles from './index.module.scss'

export default function UserChatBubbleVersionNav({
  versionLabel,
  onPrevVersion,
  onNextVersion,
  prevDisabled,
  nextDisabled,
  isEditing,
}) {
  return (
    <Box className={styles.versionNav} aria-label="Message versions">
      <button
        type="button"
        className={styles.versionButton}
        aria-label="Previous version"
        disabled={prevDisabled}
        tabIndex={isEditing ? -1 : 0}
        onClick={() => onPrevVersion?.()}
      >
        <ChevronLeft20Regular />
      </button>
      <span className={styles.versionLabel} aria-label="Version index">
        {versionLabel}
      </span>
      <button
        type="button"
        className={styles.versionButton}
        aria-label="Next version"
        disabled={nextDisabled}
        tabIndex={isEditing ? -1 : 0}
        onClick={() => onNextVersion?.()}
      >
        <ChevronRight20Regular />
      </button>
    </Box>
  )
}
